const inView = (el:HTMLElement): Boolean => {
  const bcr = el.getBoundingClientRect();
  const top = bcr.top
  const bottom = bcr.top + bcr.height
  const ch = document.documentElement.clientHeight
  return 0 < top && top < ch || 0 < bottom && bottom < ch;
}

export { inView }
